import { render, staticRenderFns } from "./MakeKorlor.vue?vue&type=template&id=63ac9430&scoped=true"
import script from "./MakeKorlor.vue?vue&type=script&lang=js"
export * from "./MakeKorlor.vue?vue&type=script&lang=js"
import style0 from "./MakeKorlor.vue?vue&type=style&index=0&id=63ac9430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ac9430",
  null
  
)

export default component.exports